import { serviceBySlug } from "@/lib/service-offers";
import prerenderRoutes from "@/lib/prerender-routes.json";

export const SITE_ORIGIN = "https://salescan.ca";
export const prerenderPaths = prerenderRoutes;

const HOME = {
    title: "SalesCan — AI software, websites, and automation",
    description:
        "We build AI-powered SaaS, websites, and automation real businesses run on. Founder-led, fixed fee, no lock-in. St. Catharines, Canada.",
    path: "/",
};

const PAGES = {
    "/pricing": {
        title: "Pricing — SalesCan",
        description:
            "Fixed-fee websites, AI chatbots, CRM automation, and workflows for Canadian businesses. The price is set before anyone builds.",
    },
    "/services": {
        title: "Services — SalesCan",
        description:
            "AI-powered websites and business automation. Fixed fee, founder-led, full handover, and no lock-in.",
    },
    "/services/sales": {
        title: "Sales Management — Services — SalesCan",
        description:
            "We take a sales process that is leaking, rebuild how deals move, and put AI on the work a team should not do by hand.",
    },
    "/products": {
        title: "Products — SalesCan",
        description:
            "Vertical AI software SalesCan designs, builds, and operates. Real estate, compliance, HVAC, aviation, and wineries.",
    },
    "/websites": {
        title: "$199 Website — SalesCan",
        description:
            "A one-page website for $199 CAD. One revision, 24–48 hours once we have your details. You own the site.",
    },
    "/privacy": {
        title: "Privacy — SalesCan",
        description:
            "What SalesCan collects when you write to us, and what we do with it. A plain-language notice, not a legal opinion.",
    },
    "/terms": {
        title: "Terms — SalesCan",
        description: "How a SalesCan engagement works. A quote is not a contract until both sides agree in writing.",
    },
};

export function metaForPath(pathname) {
    const path = pathname.length > 1 ? pathname.replace(/\/$/, "") : "/";
    if (path === "/" || path === "/about" || path === "/contact" || path === "/work") return HOME;
    if (PAGES[path]) return { ...PAGES[path], path };
    if (path.startsWith("/services/")) {
        const offer = serviceBySlug(path.slice("/services/".length));
        if (offer) {
            return {
                title: `${offer.menu} — Services — SalesCan`,
                description: offer.card,
                path,
            };
        }
    }
    return HOME;
}

export const organizationJsonLd = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    name: "SalesCan",
    url: `${SITE_ORIGIN}/`,
    email: "William@SalesCan.ca",
    telephone: "+1-365-855-2485",
    image: `${SITE_ORIGIN}/logo.png`,
    address: {
        "@type": "PostalAddress",
        streetAddress: "110 James St",
        addressLocality: "St. Catharines",
        addressRegion: "ON",
        postalCode: "L2R 7E8",
        addressCountry: "CA",
    },
    areaServed: "CA",
};
